<template>
  <div
    class="activity full row"
    v-scroll-nav="{ path: '/value/' + activity.id, onEnter: createGraph }"
  >
    <div class="col-6">
      <div class="info-wrapper">
        <div class="overlay active pad">
          <div class="recap">
            <p v-animate-in="{ delay: 1 }">
              {{
                $t('value-activity-for-year', {
                  activity: activity.title[$i18n.locale],
                  year: $config.year
                })
              }}
            </p>
            <h3 v-animate-in><NumberTween :value="activity.value" /></h3>
          </div>
          <div class="title">
            <h2 v-animate-in>{{ activity.title[$i18n.locale] }}</h2>
            <CTA
              :cta="$t('value-show-activities')"
              type="line"
              size="big"
              @click.native="toggleDetails(true)"
              v-animate-in="{ delay: 0.75 }"
            />
          </div>
          <div class="cta">
            <CTA
              :cta="$t('value-behind-number')"
              type="circle"
              @click.native="toggleAside(true)"
              v-animate-in="{ delay: 0.85 }"
            />
          </div>
        </div>
        <SingleBlock :item="block" :max="total" :min="min" ref="graph" :tilt="1.08" />
      </div>
    </div>
    <div class="col-4 image">
      <img :src="getImageOrientation(activity.cover)" />
    </div>
    <Aside :active="showAside" @close="toggleAside(false)">
      <BehindTheNumber />
    </Aside>
    <Aside :full="true" :active="showDetails" @close="toggleDetails(false)">
      <ActivityDetails :activity="activity" v-if="showDetails" />
    </Aside>
  </div>
</template>

<script>
import Aside from '@/components/common/Aside';
import BehindTheNumber from '@/components/activity/BehindTheNumber';
import ActivityDetails from '@/components/activity/ActivityDetails';
import CTA from '@/components/common/CTA';
import NumberTween from '@/components/common/NumberTween';
import SingleBlock from '@/components/common/graphs/SingleBlock';
import imageMixin from '@/plugins/image-mixin';

export default {
  name: 'Activity',
  mixins: [imageMixin],
  components: {
    ActivityDetails,
    BehindTheNumber,
    Aside,
    CTA,
    NumberTween,
    SingleBlock
  },
  props: {
    activity: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      showDetails: false,
      showAside: false
    };
  },
  watch: {
    $route(to) {
      if (!to.path.includes('details')) {
        this.toggleDetails(false, false);
      }
      if (!to.path.includes('explanation')) {
        this.toggleAside(false, false);
      }
    }
  },
  mounted() {
    console.log(this.$store.getters)
    if (this.$route.path.includes(`value/${this.activity.id}/details`))
      this.toggleDetails(true, false);
  },
  computed: {
    total() {
      return this.$store.getters['activities/total'];
    },
    activities() {
      return this.$store.getters['activities/list'];
    },
    min() {
      return this.$store.getters['activities/min'];
    },
    block() {
      return {
        ...this.activity,
        label:
          this.$options.filters.format(((this.activity.value / this.total) * 100).toFixed(1)) + '%'
      };
    }
  },
  methods: {
    createGraph() {
      if (this.$refs.graph) this.$refs.graph.next();
    },
    toggleAside(val, nav = true) {
      this.showAside = val;
      if (val && nav !== false)
        this.$router.push({ path: `/value/${this.activity.id}/explanation` });
      else if (nav) {
        const parent = this.$route.matched[this.$route.matched.length - 2];
        if (parent) this.$router.push(parent.path);
      }
    },
    toggleDetails(val, nav = true) {
      this.showDetails = val;
      if (val && nav !== false) this.$router.push({ path: `/value/${this.activity.id}/details` });
      else if (nav) {
        const parent = this.$route.matched[this.$route.matched.length - 2];
        if (parent) this.$router.push(parent.path);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.row.activity {
  overflow: hidden;
  @media screen and (max-width: $mq-tablet) {
    .col-6 {
      height: 100%;
      .info-wrapper .overlay {
        padding-top: $padding/2;
        justify-content: inherit;
        & div {
          margin-bottom: $padding/2;
        }
      }
    }
    .col-4 {
      height: 0%;
    }
  }
  .col-6 {
    background-color: $col-navy-dark;
    .recap {
      p {
        margin-bottom: 0.5rem;
        @media screen and (max-width: $mq-tablet) {
          margin-bottom: 0.3rem;
        }
        @media screen and (max-width: $mq-mobile) {
          margin-bottom: 0.5rem;
        }
      }
    }
    .title {
      h2 {
        margin-bottom: 3rem;
        @media screen and (max-width: $mq-tablet) {
          margin-bottom: 1rem;
        }
        @media screen and (max-width: $mq-mobile) {
          margin-bottom: 1.5rem;
        }
      }
    }
  }
  .image {
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}
</style>
